import { useState, useEffect, useContext } from "react";

import "./AllCourses.css";
import {
  useNavigate,
  useLocation,
  NavLink,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { TermsContext } from "../App";
import Footer from "../Components/Footer";
import useFetch from "../Components/utils/useFetch";
import Loader from "../Components/utils/Loader";
import "../Components/utils/Loader.css";
import uuid from "react-uuid";
import Breadcrumbs from "../Components/BreadCrumbs";

function AllCourses() {
  const [groupedCourses, setGroupedCourses] = useState([]);
  const [coursesData, setCoursesData] = useState([]);
  const [mobileView, setMobileView] = useState(false);
  const { get, Loading } = useFetch();
  const { terms } = useContext(TermsContext);
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams({ replace: true });
  let { id } = useParams();
  let location = useLocation();
  let [pageTitle, setPageTitle] = useState(`${id} | Sacramento State`);

  // useEffect1 - Fetch courses data
  useEffect(() => {
    get(`${id}`).then((data) => {
      setCoursesData(data);
    });
  }, [id]);

  // useEffect2 - Update grouped courses
  useEffect(() => {
    const results = coursesData.reduce((r, e) => {
      let alpha = e.subject_ldesc[0];

      if (!r[alpha]) r[alpha] = { alpha, courses: [e] };
      else r[alpha].courses.push(e);

      return r;
    }, {});

    setGroupedCourses(Object.values(results));
  }, [coursesData]);

  // Build Links for each course
  function QueryNavLink({ to, ...props }) {
    return <NavLink to={to + location.search} {...props} />;
  }

  function handleTermChange(e) {
    const changeTerm = e.target.value;
    let changeTermPath = process.env.PUBLIC_URL;
    if (process.env.PUBLIC_URL === "/") changeTermPath += changeTerm;
    else changeTermPath += "/" + changeTerm;
    console.log(changeTermPath)
    setPageTitle(`${changeTerm} | Sacramento State`);
    navigate(`${changeTermPath}`);
  }


function transormTermString(str) {
    // Trim first off string
    const trimmedStr = str.trimStart();
    // Capitalize new first letter
    const capitalizedStr = trimmedStr.charAt(0).toUpperCase() + trimmedStr.slice(1);
    // Replace hyphen with space
    const replacedStr = capitalizedStr.replace("-", " ");
    return replacedStr;
}


  useEffect(() => {
      const prettyString = transormTermString(pageTitle)
      document.title = prettyString;
  }, [pageTitle]);


  return (
    <>
      <div className="page-schedule-term">
        <article role="region" aria-label="all-courses">
          <h1>Class Schedule</h1>
          <h2 id="article-head">Courses By Major</h2>
          <form className="search-catalog">
            <fieldset role="group" aria-labelledby="filter-courses-label">
              <legend id="filter-courses-label" className="sr-only">
                Filter Courses
              </legend>
              <label
                aria-hidden="true"
                htmlFor="filter-courses"
                className="sr-only"
              >
                Filter Courses by Major
              </label>
              <input
                type="text"
                placeholder="Filter Courses"
                id="filter-courses"
                value={searchParams.get("filter") || ""}
                onFocus={() => {
                  setMobileView(true);
                }}
                onBlur={() => {
                  setMobileView(false);
                }}
                onChange={(event) => {
                  let filter = event.target.value;
                  if (filter) {
                    setSearchParams({ filter }, { replace: true });
                  } else {
                    setSearchParams({}, { replace: true });
                  }
                }}
              />
              <div
                className={
                  mobileView ? "select-wrapper hide-on-focus" : "select-wrapper"
                }
              >
                <label htmlFor="changeTerm" className="sr-only">
                  Change Term:
                </label>
                <select
                  onChange={handleTermChange}
                  defaultValue=""
                  id="changeTerm"
                  className="selectTerm"
                >
                  <option value="" disabled>
                    Select Another Term...
                  </option>
                  {terms.map((termLink) => (
                    <option key={termLink.term} value={termLink.term}>
                      {termLink.term_ldesc}
                    </option>
                  ))}
                </select>
              </div>
            </fieldset>
          </form>

          <Footer />

          <section>
            {Loading ? <Loader /> : null}
            {groupedCourses
              // Sort Array by Alpha
              .sort((a, b) => a.alpha.localeCompare(b.alpha))
              // Compare and filter Courses
              .filter((filteredAlpha) => {
                let Alphafilter = searchParams.get("filter");
                if (!Alphafilter) return true;
                let letter = filteredAlpha.alpha.substring(0, 1).toLowerCase();
                return letter.startsWith(
                  Alphafilter.substring(0, 1).toLowerCase()
                );
                // map over and build the html for filtererd results
              })
              .map((groupedCourse) => {
                return (
                  <div key={uuid()}>
                    <h3>{groupedCourse.alpha}</h3>
                    <ul>
                      {groupedCourse.courses
                        .filter((filteredCourse) => {
                          let filter = searchParams.get("filter");
                          if (!filter) return true;
                          let course =
                            filteredCourse.subject_ldesc.toLowerCase();
                          return course.startsWith(filter.toLowerCase());
                        })
                        .map((course) => {
                          return (
                            <li key={course.subject_code} className="box">
                              {/* This creates a link for the subject_code */}
                              <QueryNavLink to={course.subject_code}>
                                {course.subject_ldesc}
                              </QueryNavLink>
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                );
              })}
          </section>
        </article>
      </div>
    </>
  );
}

export default AllCourses;
